import styled, { css } from 'styled-components';
import { Heading } from '@bechtel/gds';

export const BlockHeadingStyled = styled(Heading)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    background: ${theme.colors.grey[200]};
    padding-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: ${theme.spacings[600]};
    border: solid 1px ${theme.colors.grey[300]};
    color: ${theme.colors.grey[1000]};
  `}
`;
